import script from "./AccountsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountsPage.vue?vue&type=script&setup=true&lang=ts"

import "./AccountsPage.vue?vue&type=style&index=0&id=b8cc00ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8cc00ce"]])

export default __exports__